import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';
import UploadImg from '@/pages/components/uploadImg';
import ActionSheet from '@/pages/components/common/ui/actionsheet';
import Tips from '@/pages/components/tips/index';
import alert from '@/pages/components/common/alert';
import './scss/form.scss';

interface initProps{
	history: any,
}

class ComponentAuthStep3 extends React.Component <initProps , any> {
	constructor(props: any) {
		super(props);
		this.state = {
			// 是否是企业认证变更
			actiontype: '',
			visiblity: false,
			isSubmiting: false,
			promptText: '',
			form: {
				invoiceInfo: '', // 开票资料
				authorization: '', // 授权书
				licence: '', //  营业执照
				authType: 0,
				hazardousLicence: '', // 危化品许可证
				logo: '', // 企业logo
				salesmanName: '' // 授权业务员
			},
			isInMiniProgram: false, // 是否在小程序中
		}
	}

	componentDidMount() {
		let tempActiontype = '';
		const tempState = this.props.history.location.state;
		if(tempState && tempState.actiontype) {
			tempActiontype = tempState.actiontype;
		}
		if (tempActiontype) {
			this.setState({ actiontype: tempActiontype }, () => {
				this.initData();
			});
		} else {
			this.initData();
		}

		// 判断是否在小程序中
		(window as any).wx.miniProgram.getEnv((res: any) => {
			if(res.miniprogram) {
				this.setState({
					isInMiniProgram: true
				});
			}
		});

	}

	render() {
		return (
			<div className="gray-bg">
				<Tips 
					visiblity = {this.state.visiblity}
					titleText="提交成功" 
					promptText={this.state.promptText}
					confirmFn={() => this.setState({visiblity: false},() => this.props.history.replace('/')) } />
				<div className="process">
					<div className="process-item active"> 
						<div className="num-warrrper">
							<span className="num">1</span>
						</div>
						<p className="title">工商信息</p>
					</div>
					<div className="process-item active"> 
						<div className="num-warrrper">
							<span className="num">2</span>
						</div>
						<p className="title">开票信息</p>
					</div>
					<div className="process-item active"> 
						<div className="num-warrrper">
							<span className="num">3</span>
						</div>
						<p className="title">上传附件</p>
					</div>
				</div>
				<div className="default-form margin-down-default">
					<div className="form-upload-warrper">
						<label className="label"><span className="red">*</span>营业执照</label>
						<div className="form-upload">
							<UploadImg sucess={(data: any) => this.setForm('licence', data)}  id={this.state.form.licence} />
						</div>
					</div>
					<div className="form-upload-warrper">
						<label className="label">开票资料</label>
						<div className="form-upload">
							<UploadImg sucess={(data: any) => this.setForm('invoiceInfo', data)}  id={this.state.form.invoiceInfo} />
						</div>
					</div>
					{
					// <dl className="form-cert-auth">
					// 	<dt>
					// 		<span><code className="red">*</code>认证资料</span>
					// 		<p>认证资料二选一，可选择上传授权书，也可以填写与平台联系的业务员名称</p>
					// 	</dt>
					// 	<dd>
					// 		<div className="form-upload-warrper">
					// 			<label className="label">授权书</label>
					// 			<div className="form-upload">
					// 				<UploadImg sucess={(data: any) => this.setForm('authorization', data)}  id={this.state.form.authorization} />
					// 			</div>
					// 		</div>
					// 		<div className="form-upload-warrper form-cert-auth-input">
					// 			<label className="label">业务员名称</label>
					// 			<div className="form-upload">
					// 				<input type="text" placeholder="请输入业务员名称"
					// 				onChange={ (e:any) => this.changeModelAuthPeople(e) }
					// 				value={ this.state.form.salesmanName }/>
					// 			</div>
					// 		</div>
					// 	</dd>
					// </dl>
					}
					<div className="form-upload-warrper">
						<label className="label"><span className="red">*</span>授权书</label>
						<div className="form-upload">
							<UploadImg sucess={(data: any) => this.setForm('authorization', data)}  id={this.state.form.authorization} />
						</div>
					</div>
					<div className="form-upload-warrper">
						<label className="label">危险品经营许可证</label>
						<div className="form-upload">
							<UploadImg sucess={(data: any) => this.setForm('hazardousLicence', data)}  id={this.state.form.hazardousLicence} />
						</div>
					</div>
					<div className="form-upload-warrper">
						<label className="label">企业logo</label>
						<div className="form-upload">
							<UploadImg sucess={(data: any) => this.setForm('logo', data)}  id={this.state.form.logo} />
						</div>
					</div>
				</div>

				<div className="form-btn-warrrper clearfix">
					<button className="form-btn" onClick={() =>  this.submitForm() }>提交</button>
					<button className="form-btn white" onClick={() => this.props.history.replace('/auth/step2', {actiontype: this.state.actiontype})}>返回上一步</button>
				</div>
				<ActionSheet />
			</div>
		)
	}

	// 返回初始化数据
	private async initData() {
		const r = await request({
			method: "get",
			url: `${config.CE}member/company/info?type=${this.state.actiontype}`,
		});

		if (r.code !== 1) {
			alert.open({
				promptText: r.msg,
			})
		} else {
			const {companyInfo} = r.obj;

			this.setState({
				form: {
					invoiceInfo: companyInfo ? (companyInfo.invoiceInfo ? companyInfo.invoiceInfo : '') : '', // 开票资料
					authorization: companyInfo ? (companyInfo.authorization ? companyInfo.authorization :'') : '',  // 授权书
					licence: companyInfo ? (companyInfo.licence ? companyInfo.licence : '') : '', //  营业执照
					authType: this.state.actiontype || 0,
					hazardousLicence: companyInfo ? (companyInfo.hazardousLicence ? companyInfo.hazardousLicence : '') : '', // 危化品许可证
					logo: companyInfo ? (companyInfo.logo ? companyInfo.logo : '') : '', // 企业logo
					salesmanName: companyInfo ? (companyInfo.salesmanName ? companyInfo.salesmanName : '') : ''
				}
			})
		}
	}

	// 表单赋值
	private setForm(name?: string, val?: any) {
		if(!name) {
			return ;
		}
		this.state.form[name] = val;
		this.setState({
			form: { 
				...this.state.form,
			} 
		})
	}

	private checkForm() {
		if(this.state.form.licence === '') {
			alert.open({
	    		promptText: '请选择营业执照',
	    	})
			return ;
		}

		if( this.state.form.authorization === '') {
			alert.open({
	    		promptText: '请选择授权书',
	    	})
			return ;
		}
		return true;
	}

	// 提交表单
	private async submitForm() {
		if(!this.checkForm()) {
			return ;
		}

		// 防止重复提交
		if(this.state.isSubmiting) {
			return ;
		}

		this.setState({
			isSubmiting: true
		})

		const r = await request({
	      method: "post",
	      url: `${config.CE}member/auth/company/submit/step/3`,
	      data: {
			  ...this.state.form,
			  authType: this.state.actiontype || 0
	      }
	    });

		this.setState({
			isSubmiting: false,
		})

	    if(r.code !== 1) {
	    	alert.open({
	    		promptText: r.msg,
	    	})
	    }else {
			// 如果是在小程序中
	    	if (this.state.isInMiniProgram) {
				alert.open({
		    		promptText: '提交成功',
		    		callback: () => {
		    			(window as any).wx.miniProgram.switchTab({url: '/pages/index/index'})
		    		}
		    	})
	    	} else {
	    		this.setState({
		    		visiblity: true,
		    		promptText: r.message,
		    		form: {
						invoiceInfo: '', // 开票资料
						authorization: '', // 授权书
						licence: '', //  营业执照
						authType: this.state.actiontype || 0,
						hazardousLicence: '', // 危化品许可证
						logo: '', // 企业logo
						salesmanName: ''
					}
		    	});
	    	}
	    }
	}
	// 输入业务员
	// private changeModelAuthPeople(e: any) {
	// 	const form = this.state.form;
	// 	form.salesmanName = e.target.value;
	// 	this.setState({
	// 		form
	// 	});
	// }

}

export default ComponentAuthStep3;